var __jsx = React.createElement;
import React, { useState } from 'react';
import MuscleModal from '../../../components/modal';
import CustomerLoginForm from './components/customer-login-form';
import RegisterFlow from '../register-flow';
import ForgotPasswordFlow from '../forgot-password-flow';
const LoginFlow = _ref => {
  let {
    isOpen,
    setIsOpen
  } = _ref;
  const {
    0: registerModalIsOpen,
    1: setRegisterModalIsOpen
  } = useState(false);
  const {
    0: forgotPasswordModalIsOpen,
    1: setForgotPasswordModalIsOpen
  } = useState(false);
  return __jsx(React.Fragment, null, __jsx(MuscleModal, {
    dataTestId: "login-modal",
    openState: isOpen,
    setOpenState: setIsOpen
  }, __jsx(CustomerLoginForm, {
    onLoginCallback: () => setIsOpen(false),
    onClickForgotPassword: () => {
      setIsOpen(false);
      setForgotPasswordModalIsOpen(true);
    },
    onClickRegisterHere: () => {
      setIsOpen(false);
      setRegisterModalIsOpen(true);
    }
  })), __jsx(RegisterFlow, {
    isOpen: registerModalIsOpen,
    setIsOpen: setRegisterModalIsOpen
  }), __jsx(ForgotPasswordFlow, {
    isOpen: forgotPasswordModalIsOpen,
    setIsOpen: setForgotPasswordModalIsOpen
  }));
};
export default LoginFlow;